module.exports = __webpack_public_path__ + "static/media/IMG_1905.25c4bd0c.JPG";